import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppInstallationsKey, getAppKey, getAppsKey } from '../../utils/keys';
export const useInstallApp = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.app.install(input, fields), {
        onMutate: variables => {
            const appKey = getAppKey({ id: variables.appId });
            queryClient.setQueriesData(appKey, old => ({
                ...old,
                installed: true,
            }));
            const appsKey = getAppsKey();
            queryClient.setQueriesData(appsKey, old => {
                var _a, _b;
                return ({
                    ...old,
                    edges: (_a = old === null || old === void 0 ? void 0 : old.edges) === null || _a === void 0 ? void 0 : _a.map(edge => ({
                        ...edge,
                        node: {
                            ...edge.node,
                            installed: edge.node.id === variables.appId ? true : edge.node.installed,
                        },
                    })),
                    nodes: (_b = old === null || old === void 0 ? void 0 : old.nodes) === null || _b === void 0 ? void 0 : _b.map(node => ({
                        ...node,
                        installed: node.id === variables.appId ? true : node.installed,
                    })),
                });
            });
        },
        onSettled: (data, error, variables) => {
            const appKey = getAppKey({ id: variables.appId });
            queryClient.invalidateQueries(appKey);
            const appsKey = getAppsKey();
            queryClient.invalidateQueries(appsKey);
            const appInstallationsKey = getAppInstallationsKey();
            queryClient.invalidateQueries(appInstallationsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useInstallApp.js.map